import { useEffect } from 'react';
import { siteInfo } from '@/mocks/site';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  ogImage?: string;
  noIndex?: boolean;
}

export default function SEO({ title, description, keywords, canonicalPath, ogType = 'website', ogImage, noIndex }: SEOProps) {
  useEffect(() => {
    const fullTitle = title.includes(siteInfo.name) ? title : `${title} - ${siteInfo.name}`;
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const canonicalUrl = canonicalPath ? `${siteInfo.url}${canonicalPath}` : siteInfo.url;

    setMeta('description', description);
    setMeta('keywords', keywords || '高义白洁,高义白洁的意思,高义白洁典故,高义白洁出处,君子品格,高洁志节,传统美德');
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('og:site_name', siteInfo.name, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
      setMeta('og:image:width', '1200', true);
      setMeta('og:image:height', '630', true);
    }
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);

    let linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!linkEl) {
      linkEl = document.createElement('link');
      linkEl.setAttribute('rel', 'canonical');
      document.head.appendChild(linkEl);
    }
    linkEl.setAttribute('href', canonicalUrl);

    if (noIndex) {
      setMeta('robots', 'noindex, follow');
    }

    return () => {
      // cleanup not needed as next page will override
    };
  }, [title, description, keywords, canonicalPath, ogType, ogImage, noIndex]);

  return null;
}